import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import {
    ProcessReportResourceService
} from "app_sasha/shared/resources/process-report/process-report-resource.service";


@NgModule({
    imports: [
        CommonModule
    ],

    providers: [
        ProcessReportResourceService,
    ],
})
export class ProcessReportResourceModule {
}
